import { Injector } from "@angular/core";
import { TreeNode } from "primeng/api";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeAttachmentList } from "../ListEntity/TreeNodeAttachmentList";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { ProductAttachment } from "../../../Data/Art57Data/ProductAttachment";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { ErrorType } from "../../ErrorType";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeProductAttachment extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {

      let operationtype = undefined;
      if (parent && 
          parent.parent && 
          parent.parent.data &&
          parent.parent.data.model){
        operationtype = parent.parent.data.model.operationtype;
      }

      super(injector, new ProductAttachment(new FieldDefinition(injector),operationtype),'Attachment');

      this.parent = parent;
      this.labelNodeName = 'Product Attachment';      
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(lazy:boolean=true): void {
      // TODO: Fix local or remote attachment lookup actualy all are set as Remote
      if (this.data && this.data.model &&
        this.data.model.attachmentcode &&
        this.data.model.attachmentcode.value) {
          if (this.data.model.attachmentcode.name) {
            this.label = this.data.model.attachmentcode.name;                
          } else if (!lazy) { 
            this.ioc!.get(LookupGetService).getLookup('ppiattachment',this.data.model.attachmentcode.value)
            .then((result: CodeName) => {
               if (result && result.name && result.name != '') {
                this.data.model.attachmentcode.name = result.name;
                this.refreshLabel();
               } else {
                this.label = this.labelTemplate;
               } 
            });
          }   
        } else {
          this.label = this.labelTemplate;
        } 

    }
  
    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.attachmentcode &&
          this.data.model.attachmentcode.value
          ? this.data.model.attachmentcode.value
          : 'Not selected',
        this.data.model &&
          this.data.model.attachmentcode &&
          this.data.model.attachmentcode.name
          ? this.data.model.attachmentcode.name
          : this.label,
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeProductAttachment = new TreeNodeProductAttachment(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    getAttachmentListRootNode(): TreeNode<any> | null {
      let attachmentsNodeList: TreeNode<any> | null;
      let rootNode: any = this;
      while (rootNode.parent != null) {
        if (rootNode.parent != null) {
          rootNode = rootNode.parent;
        }
      }
  
      attachmentsNodeList = Art57NodeUtils.findFirstChildNodeOfType(
        rootNode,
        TreeNodeAttachmentList
      );
  
      return attachmentsNodeList;
    }
  
  
  
    existsPPIAttachment(attachmentsNodeList: any, localnumber: any): boolean {
      let existNode: boolean = false;
  
      for (let i = 0; i < attachmentsNodeList!.children!.length; i++) {
        let childAttachment = attachmentsNodeList!.children![i];
        if (
          childAttachment.data.model.attachmenttype == 1 &&
          childAttachment.data.model.localnumber == localnumber
        ) {
          existNode = true;
          break;
        }
      }
  
      return existNode;
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      let attachmentsNodeList = this.getAttachmentListRootNode();
  
      if (
        this.data.model.attachmentcode.resolutionmode == 1 &&
        !this.existsPPIAttachment(
          attachmentsNodeList,
          this.data.model.attachmentcode.value
        )
      ) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: "PPI attachment doesn't exists",
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }

      errors.push(...ErrorControlUtil.sameReferenceByValue(this, "attachmentcode.value"));

      return errors;
    }
   
  }

